<div class="bbrowser-container">
  @if (!loadingBB && !lastError) {
    <div class="tools">
      @if (showSlider) {
        <div class="tools-group">
          <div>Change opacity</div>
          <input type="range" min="-1" max="101" [(ngModel)]="opacity"
            (change)="changeOpacity(opacity)" />
          </div>
        }
        <div class="tools-group autorotate">
          <span>Autorotate</span>
          <div class="flex-row">
            <div class="btn-group">
              <fw-button size="small" [color]="xRotActive ? 'primary' : 'slate'"
                [variant]="xRotActive ? 'solid' : 'outline'"
              (click)="setRotation('x')">x</fw-button>
              <fw-button size="small" [color]="yRotActive ? 'primary' : 'slate'"
                [variant]="yRotActive ? 'solid' : 'outline'"
              (click)="setRotation('y')">y</fw-button>
              <fw-button size="small" [color]="zRotActive ? 'primary' : 'slate'"
                [variant]="zRotActive ? 'solid' : 'outline'"
              (click)="setRotation('z')">z</fw-button>
            </div>
            <fw-button size="small" color="primary" variant="outline" (click)="resetView()">Reset view</fw-button>
          </div>
        </div>
        <div class="tools-group background">
          Background Color: <input type="color" [(ngModel)]="bbrowserColor" (change)="setBackgroundcolor(bbrowserColor)">
        </div>
        <hr />
        @if (!isMni) {
          <div class="tools-group">
            <div>Select a point</div>
            <div>(Shift+click on the surface)</div>
            <br />
            <div>X: {{selectedPoint.x}}</div>
            <div>Y: {{selectedPoint.y}}</div>
            <div>Z: {{selectedPoint.z}}</div>
            <div>Vertex number: {{selectedPoint.vertex}}</div>
            @if (selectedPoint.value) {
              <div>Value: {{selectedPoint.value}}</div>
            }
          </div>
        }
        <!-- FIXME: Currently never shown -->
        @if (isMni) {
          <div class="tools-group">
            <fw-button size="small" color="primary" variant="outline"
            [disabled]="hasMniTemplate" (click)="addMniTemplate()">Add mni template</fw-button>
          </div>
        }
      </div>
    }
    @if (!lastError) {
      <div id="bbrowser-viewer"></div>
    }
  </div>

  @if (loadingBB && !lastError) {
    <div class="spinner-container">
      <fw-progress-spinner mode="indeterminate" size="medium" [showValue]="false"></fw-progress-spinner>
    </div>
  }

  @if (lastError) {
    <div class="error-message">
      <fw-icon size="large" color="primary">warning</fw-icon>
      <div class="vision-h1">Error loading BrainBrowser</div>
    </div>
  }

  <router-outlet />
